import { redirectToUrl } from "@/src/utils/safeNavigation";

export function redirectToLoginIfSessionExpired(status: number): boolean {
  if (status !== 401 || !window.EASY.currentUser?.logged) return false;

  window.__easyRedirectingToLogin = true;
  window.onbeforeunload = null;
  const backUrl = encodeURIComponent(window.location.href);
  redirectToUrl(`${window.urlPrefix || ""}/login?back_url=${backUrl}`);
  return true;
}
